'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getError = exports.isSilent = exports.ignoreError = exports.getDisplayEventId = exports.getErrorMessage = exports.getErrorTitle = exports.getErrorMeta = exports.getErrorInPayload = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorInPayload = exports.getErrorInPayload = (0, _getIn2.default)(['payload', 'error']);

var getErrorMeta = exports.getErrorMeta = (0, _getIn2.default)(['meta', 'error']);

var getErrorTitle = exports.getErrorTitle = (0, _getIn2.default)(['meta', 'error', 'titleText']);

var getErrorMessage = exports.getErrorMessage = (0, _getIn2.default)(['meta', 'error', 'message']);

var getDisplayEventId = exports.getDisplayEventId = function getDisplayEventId(action) {
  return (0, _getIn2.default)(['meta', 'error', 'displayEventId'], action) !== false;
};

var ignoreError = exports.ignoreError = (0, _getIn2.default)(['meta', 'error', 'ignore']);

var isSilent = exports.isSilent = (0, _getIn2.default)(['meta', 'error', 'silent']);

var getError = exports.getError = function getError(action) {
  if (action.payload instanceof Error) {
    return action.payload;
  }

  var errorInPayload = getErrorInPayload(action);
  if (errorInPayload instanceof Error) {
    return errorInPayload;
  }

  return null;
};